export const MAIN_TEXT_COLOR = "#50555a";
export const DESCRIPTION_TEXT_COLOR = MAIN_TEXT_COLOR;
export const SUB_DESCRIPTION_TEXT_COLOR = "#95A1B8";

export const MAIN_PRIMARY_COLOR = "#4a61dd";
export const MAIN_ENDYSOFT_LOGO_RED_COLOR = "#CF2424";
export const MAIN_BLUE_BG_COLOR = "#3d60f4";
export const MAIN_WHITE_TEXT_COLOR = "#ffffff";